import React from 'react';
export const HowWeInvestPage = () => {
  const investmentAreas = [{
    title: 'Enterprise Software',
    description: 'We back founders building next-generation tools and platforms for businesses to operate more efficiently.',
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-83">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-84" />
        </svg>
  }, {
    title: 'Infrastructure & Cloud',
    description: 'We invest in the foundational technologies that power modern applications and services.',
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-85">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" data-id="element-86" />
        </svg>
  }, {
    title: 'AI & Machine Learning',
    description: 'We support teams creating the next wave of AI-powered applications and infrastructure.',
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-87">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" data-id="element-88" />
        </svg>
  }, {
    title: 'Fintech',
    description: 'We invest in companies reimagining financial services through technology.',
    icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-89">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-90" />
        </svg>
  }];
  const investmentStages = [{
    stage: 'Seed',
    description: 'We partner with founders at the earliest stages, typically investing $1-3M as they build their initial product and find product-market fit.',
    typical: '$1-3M'
  }, {
    stage: 'Series A',
    description: 'We support companies that have demonstrated product-market fit and are ready to scale, with investments typically ranging from $5-10M.',
    typical: '$5-10M'
  }, {
    stage: 'Follow-on',
    description: 'We continue to support our portfolio companies in later rounds, often participating in Series B and beyond alongside other investors.',
    typical: 'Varies'
  }];
  return <div className="w-full bg-white" data-id="element-91">
      {/* Hero Section */}
      <section className="w-full py-20 px-6 md:px-12 bg-white" data-id="element-92">
        <div className="max-w-7xl mx-auto" data-id="element-93">
          <h1 className="text-4xl md:text-6xl font-bold text-[#070707] leading-tight mb-8" data-id="element-94">
            How We Invest
          </h1>
          <p className="text-xl md:text-2xl text-[#070707] max-w-4xl mb-8" data-id="element-95">
            Race Capital partners with exceptional entrepreneurs building
            category-defining companies in enterprise, infrastructure, and
            beyond.
          </p>
          <div className="bg-gray-50 p-6 md:p-8 rounded-lg border border-gray-200 mt-12" data-id="element-96">
            <p className="text-lg text-[#070707]" data-id="element-97">
              "We don't just invest capital. We invest our time, network, and
              expertise to help founders navigate the challenges of building
              transformative companies."
            </p>
            <p className="text-red-600 font-medium mt-4" data-id="element-98">— Race Capital Team</p>
          </div>
        </div>
      </section>
      {/* Investment Philosophy */}
      <section className="w-full py-16 px-6 md:px-12 bg-gray-50" data-id="element-99">
        <div className="max-w-7xl mx-auto" data-id="element-100">
          <h2 className="text-3xl font-bold text-[#070707] mb-10" data-id="element-101">
            Our Investment Philosophy
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-102">
            <div data-id="element-103">
              <h3 className="text-xl font-semibold mb-4 text-[#070707]" data-id="element-104">
                Founder-First Approach
              </h3>
              <p className="text-[#070707]" data-id="element-105">
                We believe in backing exceptional founders with deep domain
                expertise and a clear vision for transforming their industries.
                Our partnership begins with the people behind the company, and
                we're committed to supporting them throughout their journey.
              </p>
            </div>
            <div data-id="element-106">
              <h3 className="text-xl font-semibold mb-4 text-[#070707]" data-id="element-107">
                Long-Term Vision
              </h3>
              <p className="text-[#070707]" data-id="element-108">
                We invest in companies that have the potential to define and
                lead categories. We're not looking for incremental improvements,
                but for bold ideas that can reshape industries and create
                lasting impact.
              </p>
            </div>
            <div data-id="element-109">
              <h3 className="text-xl font-semibold mb-4 text-[#070707]" data-id="element-110">
                Active Partnership
              </h3>
              <p className="text-[#070707]" data-id="element-111">
                Beyond capital, we provide strategic guidance, operational
                support, and access to our network of industry experts,
                potential customers, and future investors. We roll up our
                sleeves and work alongside our founders.
              </p>
            </div>
            <div data-id="element-112">
              <h3 className="text-xl font-semibold mb-4 text-[#070707]" data-id="element-113">
                Speed & Conviction
              </h3>
              <p className="text-[#070707]" data-id="element-114">
                We move quickly and with conviction when we find the right
                opportunity. Our streamlined decision-making process allows us
                to be responsive to founders' needs and provide capital
                efficiently.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Investment Areas */}
      <section className="w-full py-16 px-6 md:px-12 bg-white" data-id="element-115">
        <div className="max-w-7xl mx-auto" data-id="element-116">
          <h2 className="text-3xl font-bold text-[#070707] mb-10" data-id="element-117">
            Investment Focus Areas
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-118">
            {investmentAreas.map((area, index) => <div key={index} className="bg-white p-6 rounded-lg border border-gray-200 hover:shadow-md transition-shadow" data-id="element-119">
                <div className="mb-4" data-id="element-120">{area.icon}</div>
                <h3 className="text-xl font-semibold mb-3 text-[#070707]" data-id="element-121">
                  {area.title}
                </h3>
                <p className="text-[#070707]" data-id="element-122">{area.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Investment Stages */}
      <section className="w-full py-16 px-6 md:px-12 bg-gray-50" data-id="element-123">
        <div className="max-w-7xl mx-auto" data-id="element-124">
          <h2 className="text-3xl font-bold text-[#070707] mb-10" data-id="element-125">
            Investment Stages
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-126">
            {investmentStages.map((item, index) => <div key={index} className="bg-white p-6 rounded-lg border border-gray-200 hover:shadow-md transition-shadow" data-id="element-127">
                <div className="flex items-center justify-between mb-4" data-id="element-128">
                  <h3 className="text-xl font-semibold text-[#070707]" data-id="element-129">
                    {item.stage}
                  </h3>
                  <span className="bg-red-100 text-red-600 px-3 py-1 rounded-full text-sm font-medium" data-id="element-130">
                    {item.typical}
                  </span>
                </div>
                <p className="text-[#070707]" data-id="element-131">{item.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="w-full py-16 px-6 md:px-12 bg-white" data-id="element-132">
        <div className="max-w-7xl mx-auto" data-id="element-133">
          <div className="bg-gray-50 rounded-xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between" data-id="element-134">
            <div className="mb-8 md:mb-0 md:mr-8" data-id="element-135">
              <h2 className="text-3xl font-bold text-[#070707] mb-4" data-id="element-136">
                Ready to Partner?
              </h2>
              <p className="text-lg text-[#070707] max-w-2xl" data-id="element-137">
                If you're building something transformative and looking for a
                partner who can help accelerate your journey, we'd love to hear
                from you.
              </p>
            </div>
            <button className="bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-8 rounded-md transition-colors whitespace-nowrap" data-id="element-138">
              PITCH US
            </button>
          </div>
        </div>
      </section>
    </div>;
};